import script from "./Withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./Withdraw.vue?vue&type=script&setup=true&lang=js"

import "./Withdraw.vue?vue&type=style&index=0&id=85253e3c&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85253e3c"]])

export default __exports__